<template lang="html">
  <v-dialog
    v-model="internalValue"
    max-width="600"
  >
    <v-card>
      <v-card-title class="headline">
        New Calculator
      </v-card-title>
      <v-card-text>
        <SiVariableEditor
          ref="variableEditor"
          active
          variable-term="calculator Id"
          regex="^[a-z]{3,5}$"
          regex-error-text="Calculator id's must only contain letters and be at least three characters long"
          :existing-variables="_calculators"
          @variable="newCalculator"
          @cancel="internalValue = false"
        />
      </v-card-text>
      <v-divider />
      <!-- <v-card-text> -->
      <v-card-actions>
        <SiFileUpload
          ref="file"
          accept="json"
          disable-upload
          @update="processUploadFile"
        />
        <v-btn
          text
          color="info"
          @click="importCalculator"
        >
          <v-icon left>
            vertical_align_top
          </v-icon> Import Calculator
        </v-btn>
      </v-card-actions>
      <v-dialog
        v-model="warning"
        persistent
        :overlay="false"
        max-width="400px"
      >
        <v-card>
          <v-card-title class="headline error white--text">
            <v-icon
              left
              color="white"
            >
              warning
            </v-icon> Overwrite Calculator
          </v-card-title>
          <v-card-text>
            A calculator with the id <strong>{{ warningId }}</strong> already exists. <br><br> Importing the file you have selected will overwrite this calculator. Are you absolutely sure you want to continue? This cannot be undone!
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              color="grey"
              @click="warning = false"
            >
              cancel
            </v-btn>
            <v-btn
              text
              color="error"
              @click="createCalculator"
            >
              Yes, Overwrite
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="notValid"
        persistent
        :overlay="false"
        max-width="400px"
      >
        <v-card>
          <v-card-title class="headline error white--text">
            <v-icon
              left
              color="white"
            >
              warning
            </v-icon> Invalid file
          </v-card-title>
          <v-card-text>
            The file you are trying to import is not valid. File must be .json format and contain:
            <pre v-text="{id: '[calculator id]', data: '[firebase update object]'}" />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              color="grey"
              @click="notValid = false"
            >
              ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- </v-card-text> -->
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { rtdb } from '@/plugins/firebase'
import helpers from '@/mixins/helpers'

export default {
  mixins: [ helpers ],
  props: {
    value: Boolean
  },
  data () {
    return {
      lazyValue: this.value,
      newCalculatorData: {},
      warning: false,
      warningId: null,
      notValid: false
    }
  },
  computed: {
    ...mapGetters(['_calculators', '_user']),
    internalValue: {
      get () {
        return this.lazyValue
      },
      set (v) {
        this.lazyValue = v
        this.$emit('input', v)
      }
    }
  },
  watch: {
    value (v) {
      this.internalValue = v
    },
    internalValue (v) {
      requestAnimationFrame(() => {
        if (v) this.$refs.variableEditor.focus()
      })
      if (!v) this.cleanUp()
    }
  },
  methods: {
    importCalculator () {
      this.$refs.variableEditor.reset()
      this.$refs.file.pickFile()
    },
    async processUploadFile (file) {
      let dateStamp = new Date()
      let reportId = Number(dateStamp)
      let timestamp = dateStamp.toISOString()
      let { uid } = this._user
      let summary = 'Calculator import'

      let { id, data } = await this._importFromJsonFile(file)

      if (!id || !data) return this.notValid = true
  
      let report = data[`calculators/${id}/report`]
      let { activeVersionId, activeVersion, _list } = report
      let version = { ...activeVersion, timestamp, id: reportId }
      let index = { ..._list[activeVersionId], timestamp, uid, summary }

      delete data[`calculators/${id}/report`]

      data[`calculators/${id}/report/activeVersion`] = version
      data[`calculators/${id}/report/activeVersionId`] = reportId
      data[`calculators/${id}/report/versions/${reportId}`] = version
      data[`calculators/${id}/report/_list/${reportId}`] = index

      this.newCalculatorData = { id, data }

      if (this._calculators && this._calculators[id]) {
        this.warning = true
        this.warningId = id
      } else {
        this.$nextTick(() => { this.createCalculator() })
      }
    },
    newCalculator (id) {
      let template = {
        _disabled: true,
        id: id,
        variants: {
          standard: { id: 'standard', index: 0 }
        }
      }

      let data = {
        [`calculators/_details/${id}`]: template,
        [`calculators/_list/${id}`]: template
      }
      this.newCalculatorData = { id: id, data: data }
      this.$nextTick(() => { this.createCalculator() })
    },
    createCalculator () {
      let id = this.newCalculatorData.id
      rtdb.ref().update(this.newCalculatorData.data).then(() => {
        this.$router.replace(`/admin/calculators/${id}`)
      })

      this.warning = false
      this.internalValue = false
    },
    cleanUp () {
      this.warning = false
      this.warningId = null
      this.newCalculatorData = {}
    }
  }
}
</script>

<style lang="css" scoped>

</style>
